module.exports = __webpack_public_path__ + "static/onion_mixed-9da205a56985511f39934e2c0fde24ca.png";